// 통화 포맷팅 유틸리티 함수들

// 숫자를 한국 통화 형식으로 포맷
export const formatCurrency = (amount: number): string => {
  return `${amount.toLocaleString()}원`;
};

// 숫자를 콤마가 포함된 문자열로 포맷 (원 단위 없이)
export const formatNumber = (num: number): string => {
  return num.toLocaleString();
};

// 금액 합계 계산
export const calculateTotal = (amounts: number[]): number => {
  return amounts.reduce((sum, amount) => sum + (amount || 0), 0);
};

// 수납 항목들의 총 수납액 계산 (미수금 제외)
export const calculateTotalReceipt = (item: any): number => {
  return (item.cashAmount || 0) + 
         (item.transferAmount || 0) + 
         (item.cardAmount || 0) + 
         (item.insuranceClaim || 0) +
         (item.healthLifeSupport || 0);
};

// 수납 항목들의 총 수납액 계산 (미수금 포함)
export const calculateTotalReceiptWithUncollected = (item: any): number => {
  return (item.cashAmount || 0) + 
         (item.transferAmount || 0) + 
         (item.cardAmount || 0) + 
         (item.uncollectedAmount || 0) +
         (item.insuranceClaim || 0) +
         (item.healthLifeSupport || 0);
};

// 배열의 특정 필드 합계 계산
export const sumByField = (items: any[], field: string): number => {
  return items.reduce((sum, item) => sum + (item[field] || 0), 0);
};